export default __webpack_public_path__ + "static/media/clouds.4aa78c98.svg";